import "./PortfolioTracker.css";

import { EllipseGroupBlueIcon } from "../../../../assets";
import { InteractionObjectType } from "../../../../constants";
import { NotesPanel } from "../../../../templates";
import {
  Button,
  Column,
  CursorDataGrid,
  MultiSelect,
  ProfileMenu,
  ProfileMenuItem,
  Row,
  Select,
} from "../../../../widget";
import { usePortfolioTracker } from "./usePortfolioTracker";

const PortfolioTracker = (): JSX.Element => {
  const {
    columns,
    isLoading,
    dropdownFilterKey,
    dropdownFiltersSelectData,
    tagsFilterSelectData,
    selectedTagKeys,
    refresh,
    hasData,
    actionsMenuOptionsList,
    exportTable,
    exportFileName,
    filterExportRows,
    filterExportColumns,
    portfolioTrackerLocalStorageItemName,
    defaultEditColumns,
    notesDealUuid,

    showActionsMenu,
    setShowActionsMenu,
    showEditColumnsPanel,
    setShowEditColumnsPanel,
    showNotesPanel,
    closeNotesPanel,

    onDropdownFilter,
    onTagsFilter,
    onChange,
  } = usePortfolioTracker();

  return (
    <div className="PortfolioTrackerContainer">
      <div className="PortfolioTrackerHeader">
        <h2 className="PortfolioTrackerTitle">Tracker</h2>
        <div>
          <Button
            text="Table options"
            icon={<EllipseGroupBlueIcon className="EllipsesWhiteIcon" />}
            corners="rounded"
            onClick={() => setShowActionsMenu(true)}
          />
          <ProfileMenu show={showActionsMenu} onClose={() => setShowActionsMenu(false)} position={{ top: "0" }}>
            {actionsMenuOptionsList.map((el) => (
              <ProfileMenuItem
                key={el.id}
                profileMenuItem={el}
                onClick={() => {
                  if (el.action) {
                    el.action();
                  }
                  setShowActionsMenu(false);
                }}
              />
            ))}
          </ProfileMenu>
        </div>
      </div>
      {!isLoading && (
        <div className="PortfolioTrackerFilters">
          <h3>Filter by</h3>
          <MultiSelect
            label=" "
            className="TagsFilter"
            placeholder="Tags"
            data={tagsFilterSelectData}
            values={selectedTagKeys}
            onChange={(keys) => onTagsFilter(keys)}
          />
          {selectedTagKeys.length > 0 && (
            <Button
              text="Clear tags filter"
              variant="reversedPrimary"
              textUnderline
              textBold
              hasNoPadding
              onClick={() => onTagsFilter([])}
            />
          )}
          <Select
            label=" "
            value={dropdownFilterKey}
            className="DealFilter"
            placeholder="Deal filters"
            data={dropdownFiltersSelectData}
            onChange={(key) => onDropdownFilter(key)}
            corners="rounded"
          />
          {dropdownFilterKey && (
            <Button
              text="Clear deal filters"
              variant="reversedPrimary"
              textUnderline
              textBold
              hasNoPadding
              onClick={() => onDropdownFilter(undefined)}
            />
          )}
        </div>
      )}
      <Row spacingV="3xl">
        <Column span={12}>
          <div className={`PortfolioTrackerDataGrid ${hasData ? "" : "NoData"} ${isLoading ? "Loading" : ""}`}>
            <CursorDataGrid
              columns={columns}
              clientSide={false}
              filterable
              filterPosition="right"
              onChange={onChange}
              data={[]}
              refresh={refresh}
              noDataMessage=""
              pagination={{ pageSize: 6 }}
              dataIsLoading={isLoading}
              infiniteScroll
              onExternalExport={exportTable}
              exportFileName={exportFileName}
              filterExportRows={filterExportRows}
              filterExportColumns={filterExportColumns}
              showTotalCount={false}
              showEditColumnsPanel={showEditColumnsPanel}
              closeEditColumnsPanel={() => setShowEditColumnsPanel(false)}
              editColumnsLocalStorageItemName={portfolioTrackerLocalStorageItemName}
              editColumnsText="Select the columns to display in the tracker. Drag headings to rearrange their left-to-right order."
              defaultEditColumns={defaultEditColumns}
              variant="seed"
            />
          </div>
        </Column>
      </Row>
      {notesDealUuid && (
        <NotesPanel
          objectUuid={notesDealUuid}
          objectType={InteractionObjectType.DEAL}
          show={showNotesPanel}
          onClose={() => closeNotesPanel()}
        />
      )}
    </div>
  );
};

export default PortfolioTracker;
